// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"cf56587c","521":"cf56587c","703":"cf56587c","736":"cf56587c"}[chunkId] + ".chunk.css";
};